export default () => {
  const init = () => {
    const technicalDataEl = document.querySelector('[data-technical]');
    const parsedData =
      technicalDataEl?.innerHTML && JSON.parse(technicalDataEl.innerHTML);
    const isLoggedIn = parsedData?.customer;
    const customerId = parsedData?.customer?.id;

    if (!isLoggedIn) {
      if (window.location.pathname === '/pages/rewards') {
        sessionStorage.setItem('visitedRewards', true);
      }
    } else {
      const visitedRewards = sessionStorage.getItem('visitedRewards');
      if (visitedRewards) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'account_login_account_create',
          action_referrer: 'loyalty_reward',
          user_id: customerId,
        });
        sessionStorage.removeItem('visitedRewards');
      }
    }
  };
  init();
};
